import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from '@mui/material';
import React from 'react';
import { useSingleGatewayNWDataTableView } from '../../NetworkSystem/NetworkMonitoriingTableView/hooks/useSingleGatewayNWDataTableView';
const NetworkTab = (props) => {
    const { gateway } = props;
    const initialDuration = 1;
    const initialRangeUnit = 'days';
    const { Table, deviceMessages } = useSingleGatewayNWDataTableView({
        gateway,
        initialDuration,
        initialRangeUnit,
    });
    return _jsx(Grid, { container: true, children: Table });
};
export default NetworkTab;
